import { requestRmaButtonsStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaButtons";

requestRmaButtonsStyles.cancelButton = {
    variant: "secondary",
};
